import React from 'react';

import { Flex } from '@chakra-ui/react';
import { CardHeader } from '@material-ui/core';
import styled from 'styled-components';

import { Public } from 'assets/assetsV1/iconComponents';

import { POST_VISIBILITY_TYPES } from 'constants/ProjectConstants';
import { getHumanReadableDate } from 'constants/helper';
import { LockIcon } from 'constants/icons';
import theme from 'constants/theme';

import { Avatar } from 'uiToolkitV1/Avatar';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

export default function CardHeaderWithBorder({
  imgSrc,
  img,
  stamp,
  title,
  createdDate,
  goToProfilePage,
  border = true,
  postVisibility = null,
  postSentiment = null,
  className = '',
}) {
  return (
    <Header
      className={className}
      avatar={imgSrc ? <Avatar onClick={goToProfilePage} src={imgSrc} sx={{ cursor: 'pointer' }} /> : img}
      action={stamp}
      title={
        <TextBodyMedium sx={{ cursor: 'pointer' }} onClick={goToProfilePage}>
          {title}
        </TextBodyMedium>
      }
      subheader={
        createdDate && (
          <Flex>
            <TextLabel color="text.g2">{getHumanReadableDate(createdDate)}</TextLabel>
            <TextLabel sx={{ margin: '0 4px' }} color="text.g2">
              •
            </TextLabel>
            {postVisibility === POST_VISIBILITY_TYPES.private.name && (
              <LockIcon size="tiniestFixed" color={theme.palette.icons.grey2} rightGutter={0.5} />
            )}
            {postVisibility === POST_VISIBILITY_TYPES.global.name && (
              <Flex>
                <Public boxSize="16px" color="text.g2" />
                <TextLabel color="text.g2">Public</TextLabel>{' '}
              </Flex>
            )}
          </Flex>
        )
      }
      border={border}
    />
  );
}

const Header = styled(CardHeader)`
  padding: 12px;
  .MuiCardHeader-content {
    flex: none;
  }
  .MuiCardHeader-action {
    align-self: center;
    margin-left: auto;
  }
  .MuiCardHeader-avatar {
    margin-right: 8px;
  }
`;
